import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  function toggleDropdown(e) {
    const label = e.target.closest('.dropdown-menu__label');
    const menu = label.nextElementSibling;
    const dropdownMenu = menu.closest('.dropdown-menu');

    document.querySelectorAll('.dropdown-menu__content').forEach((dropdown) => {
      if (dropdown !== menu) {
        dropdown.closest('.dropdown-menu')?.classList.remove('dropdown-menu--active');
      }
    });

    if (dropdownMenu) {
      dropdownMenu.classList.toggle('dropdown-menu--active');
      if (dropdownMenu.classList.contains('dropdown-menu--active')) {
        repositionDropdown(menu);
      }
    }

    document.querySelectorAll('.dropdown-button').forEach((button) => {
      button.classList.remove('dropdown-button--active');
    });

    e.stopPropagation();
  }

  const getDropdownScrollParent = (el) => {
    if (!el || el === document.body || el === document.documentElement) {
      return window;
    }

    const style = window.getComputedStyle(el);
    const overflowY = style.overflowY;
    const overflowX = style.overflowX;
    const isScrollableY = ['scroll', 'auto', 'hidden'].includes(overflowY);
    const isScrollableX = ['scroll', 'auto', 'hidden'].includes(overflowX);

    if (isScrollableY || isScrollableX) {
      return el;
    }

    return getDropdownScrollParent(el.parentElement);
  };

  const repositionDropdown = (el) => {
    const trigger = el.previousElementSibling;
    const triggerRect = trigger.getBoundingClientRect();
    const dropdownRect = el.getBoundingClientRect();
    const pageHeader = document.querySelector('.header, .ui--sidenav-mobile-bar');
    const pageHeaderHeight = pageHeader?.offsetHeight ?? 0;
    const offsetTopPosition = triggerRect.top + window.scrollY;
    const topHeightWithHeader = dropdownRect.height + pageHeaderHeight;
    const leftPosition = triggerRect.left - dropdownRect.width + 32;
    const scrollableParent = getDropdownScrollParent(el.parentNode);
    const isWindowScrollable = scrollableParent === window;
    const getPositioningContext = () => {
      if (isWindowScrollable) {
        return {
          leftEdge: 0,
          bottomEdge: $(document).height(),
          parentTriggerDirection: window.innerWidth / 2,
        };
      }

      const parentRect = scrollableParent.getBoundingClientRect();
      return {
        leftEdge: parentRect.left,
        bottomEdge: parentRect.top + parentRect.height + window.scrollY,
        parentTriggerDirection: parentRect.width / 2,
        nestedLeftPosition: triggerRect.left - parentRect.left,
      };
    };

    const context = getPositioningContext();
    const shouldPositionRight = isWindowScrollable
      ? leftPosition <= context.leftEdge
      : context.nestedLeftPosition <= context.parentTriggerDirection;

    el.classList.toggle('dropdown-menu__content--right', shouldPositionRight);

    const bottomPosition = offsetTopPosition + dropdownRect.height + 37;
    const shouldPositionOnTop =
      bottomPosition >= context.bottomEdge && offsetTopPosition > topHeightWithHeader;

    el.classList.toggle('dropdown-menu__content--top', shouldPositionOnTop);
  };

  window.addEventListener('resize', () => {
    document.querySelectorAll('.dropdown-menu--active .dropdown-menu__content').forEach((menu) => {
      repositionDropdown(menu);
    });
  });

  document.body.addEventListener('click', (e) => {
    const label = e.target.closest('.dropdown-menu__label');
    const isToggle = e.target.closest('.dropdown-menu__toggle');
    const isPersistentLink = e.target.closest('.dropdown-menu__link--persist');

    if (label) {
      toggleDropdown(e);
    } else if (!isToggle && !isPersistentLink) {
      document.querySelectorAll('.dropdown-menu__content').forEach((menu) => {
        menu.closest('.dropdown-menu')?.classList.remove('dropdown-menu--active');
      });
    }
  });
});
